// actions
import {
  FUEL_EFFICIENCY_FETCH_REQUEST,
  FUEL_EFFICIENCY_FETCH_SUCCESS,
  FUEL_EFFICIENCY_FETCH_FAILURE,
  GAS_SAVINGS_UPDATE,
} from './actions';

const GasSavings = (
  state = {
    disclaimerFuelEfficiencyUnit: '',
    gasUnit: '',
    efficiencyDataReady: false,
    fuelEfficiency: {},
    cachedIncentiveData: {},
  },
  action,
) => {
  switch (action.type) {
    case FUEL_EFFICIENCY_FETCH_REQUEST:
      return {
        ...state,
      };
    case FUEL_EFFICIENCY_FETCH_SUCCESS:
      return {
        ...state,
        cachedIncentiveData: {
          ...action.cachedIncentiveData,
        },
      };
    case GAS_SAVINGS_UPDATE:
      return {
        ...state,
        efficiencyDataReady: true,
        fuelEfficiency: {
          ...action.fuelEfficiency,
        },
      };
    case FUEL_EFFICIENCY_FETCH_FAILURE:
      return {
        ...state,
        efficiencyDataReady: false,
      };
    default:
      return state;
  }
};

export default GasSavings;
